<template>
  <div class="m-2">
    <loading-spinner v-if="loading"/>
    <template v-else>
      <div v-if="insights && insights.length > 0">
        <categorical-insight
          v-for="entry of insights"
          :key="entry.name"
          v-bind="entry"/>
      </div>
      <div v-else class="text-center m-5">
        <h3>Account not connected to External API</h3>
      </div>
    </template>
  </div>
</template>

<script>
  import axios from 'axios';
  import {fullURL} from '../../utils';
  import LoadingSpinner from '../LoadingSpinner';
  import CategoricalInsight from '../Insights/CategoricalInsight';
  import moment from 'moment';

  const LOOKUP = [{
    'key': 'risk_levels',
    'label': 'risk_group',
    'type': 'string'
  }, {
    'key': 'scored_date',
    'label': 'actual_date',
    'type': 'date'
  }, {
    'key': 'scored_time',
    'label': 'actual_date.time.group',
    'type': 'string'
  }];

  const parseCategory = (value, type) => {
    if (type === 'date') {
      return moment(value)
        .format('MMM DD, YYYY');
    }
    return value;
  };

  export default {
    name: 'ExternalAnalytics',

    components: {
      LoadingSpinner,
      CategoricalInsight
    },

    data() {
      return {
        insights: null,
        loading: true,
        stringify: JSON.stringify
      };
    },

    created() {
      axios.get(fullURL(`/external-analytics/insights`))
        .then(({data}) => {
          this.insights = this.parseData(data);
        })
        .catch(console.log)
        .finally(() => {
          this.loading = false;
        });
    },

    methods: {
      parseData(data) {
        if (!data) return null;
        return LOOKUP.map(({key, label, type}) => ({
          values: data[key].map(item => ([
            parseCategory(item[label], type),
            item.count
          ])),
          isString: true, // type === "string",
          name: key
        }));
      }
    },
  };
</script>

<style scoped>

</style>
